<div class="ebook-container container">
  <div class="description">
    <div>
      <p class="upper">nos produits</p>
      <h2>La Belgique n'attend plus que toi !</h2>
      <p>
        Dans cet e-book gratuit, nous t’emmenons sur 5 de nos randonnées préférée.
        <br />Une manière de sortir des sentiers battus et découvrir la Belgique comme tu ne l’as
        jamais vue !
      </p>
    </div>
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a href="/ebooks/5-randonnees-belgique">
        <ng-container>Recevoir l'ebook gratuitement</ng-container>
        <div class="line"></div>
      </a>
    </div>
  </div>
  <div class="illustration">
    <div class="cover">
      <img
        loading="lazy"
        alt="see more"
        ngSrc="/icons/eye.svg"
        class="eye"
        width="39"
        height="23"
      />
      <img
        loading="lazy"
        alt="ebook mobile"
        ngSrc="/ebook/ebook-mobile.webp"
        class="mobile"
        width="677"
        height="1300"
      />
      <img
        loading="lazy"
        alt="ebook desktop"
        ngSrc="/ebook/ebook-desktop.webp"
        class="desktop"
        width="846"
        height="1200"
      />
      <div class="pluses">
        <img
          *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]"
          loading="lazy"
          alt="plus"
          ngSrc="/icons/plus.svg"
          class="plus"
          width="40"
          height="40"
        />
      </div>
    </div>
  </div>
</div>
